import './style.scss'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom' 
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import { AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenContainer } from 'src/style'
import utility, { handleTypeNumberControl } from 'src/utils/utility'
import { FiChevronDown } from 'react-icons/fi'
import helpers from 'src/utils/helpers'
import { IoArrowBackOutline } from 'react-icons/io5'


export const InfoConfirmationD1: React.FC<any> = () => {
    const navigate = useNavigate()
    const {notifier} = useContext(VisibilityContext)
    const {info, setInfoProperty} = useContext(AppInfoContext)
    const {user: {onboardingInput, userPreAuthInfo}, setUserProperty} = useContext(UserContext)
    const [onboardingType, setOnboardingType] = useState(info.onboardingType)
    const [input, setInput] = useState({
        firstName: '', middleName: '', lastName: '', dateOfBirth: '',
        phoneNo: '', gender: '', emailAddress: '', salutation: '',
        fullAddress: '', maritalStatus: '', placeOfBirth: '', 
        occupation: '', nextOfKinName: '', nextOfKinPhoneNo: ''
    })
    const isOrganizational = onboardingInput?.isOrganizational

    let isRfsFlow = info.institutionData.onboardingFlow === 'RFS'

    useEffect(() => {
        if (info.onboardingType) setOnboardingType(info.onboardingType)
    }, [info.onboardingType])

    useEffect(() => {
        if (userPreAuthInfo) {
            const {firstName, otherName, lastName, dateOfBirth, phoneNo, emailAddress, fullAddress, gender} = userPreAuthInfo
            setInput({
                ...input, firstName, lastName, middleName: otherName, dateOfBirth, phoneNo,
                gender: onboardingInput?.gender || String(gender), emailAddress: onboardingInput.emailAddress || emailAddress,
                salutation: onboardingInput?.salutation, fullAddress: onboardingInput?.fullAddress || fullAddress,
                maritalStatus: onboardingInput?.maritalStatus
            }) 
        }
    }, [userPreAuthInfo])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    const handleAddressInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>)=>{
        const {name, value} = e.target;
        const sanitizedValue = value.replace(/[^a-zA-Z0-9\s,.'-/]/g, '');
        setInput({
            ...input,
            [name]: sanitizedValue,
        });
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (!helpers.validateEmail(input.emailAddress)) return notifier.show('Kindly provide a valid email address', 'Validation Response')
        
        setInfoProperty('onboardingProcessStatus', {...info.onboardingProcessStatus, isConfirmedInfo: true, isIdentityVerified: true})
        setUserProperty('onboardingInput', {
            ...onboardingInput, ...input,
            email: onboardingInput.email || input.emailAddress,
            address: input.fullAddress
        })
        
        if (!isRfsFlow || onboardingType === 'existing-user') navigate('/onboarding/credentials-creation')
        else navigate('/onboarding/referral')
    }

    return (
        <>
            <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
                <CustomContainer className='onboarding-screen-container_large'>
                    <AppText 
                        textSize='3' color='#101828' 
                        bottomMargin='1.5' fontFamily='Gilmer-Bold'
                    >
                        Confirmation
                    </AppText>
                    <AppSpan>Kindly Confirm your BVN retrieved information as you proceed</AppSpan>

                    <Form topMargin='3' onSubmit={handleSubmit}>
                        {!isOrganizational && (
                              <FlexRow 
                              justifyContent='space-between' gap='2'
                              className='onboarding-input-row'
                          >
                              <FormGroup bottomMargin='0'>
                                  <label>First Name</label>
                                  <input 
                                      name='firstName'
                                      placeholder='Enter First Name'
                                      value={input.firstName}
                                      onChange={handleInput}
                                      autoComplete="off"
                                      disabled={!isRfsFlow}
                                      required
                                  />
                              </FormGroup>
                              <FormGroup bottomMargin='0'>
                                  <label>Middle Name</label>
                                  <input 
                                      name='middleName'
                                      placeholder='Enter Middle Name'
                                      value={input.middleName}
                                      onChange={handleInput}
                                      autoComplete="off"
                                      disabled={!isRfsFlow}
                                      required
                                  />
                              </FormGroup>
                          </FlexRow>
                        )}
                      
                        <FlexRow
                            justifyContent='space-between' gap='2'
                            className='onboarding-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>{ isOrganizational ? 'Organizational Name' : 'Last Name'}</label>
                                <input 
                                    name='lastName'
                                    placeholder= {isOrganizational ? 'Enter organizational Name' : 'Enter Last Name'}
                                    value={input.lastName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    disabled={!isRfsFlow}
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Phone Number</label>
                                <input 
                                    type='number'
                                    name='phoneNo'
                                    placeholder='Enter Phone Number'
                                    value={input.phoneNo}
                                    onChange={handleInput}
                                    onKeyDown={handleTypeNumberControl}
                                    onKeyUp={handleTypeNumberControl}
                                    autoComplete="off"
                                    disabled={!isRfsFlow}
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        {!isOrganizational && (
                             <FlexRow
                             justifyContent='space-between' gap='2'
                             className='onboarding-input-row'
                         >
                             <FormGroup bottomMargin='0'>
                                 <label>Date of Birth</label>
                                 <input 
                                     placeholder='dd/mm/yyyy' 
                                     type='date'
                                     name='dateOfBirth'
                                     style={{color: input.dateOfBirth ? '#000000' : '#667085'}}
                                     value={input.dateOfBirth}
                                     onChange={handleInput}
                                     autoComplete="off"
                                     disabled={!isRfsFlow}
                                     required
                                 />
                             </FormGroup>
                         </FlexRow>
                        )}
                       
                        <CustomContainer topMargin='1.5'>
                            <FlexRow gap='2' bottomMargin='2'>
                                <AppText width='20'>Other Information</AppText>
                                <CustomContainer bgColor='#0D968F' height='0.091' />
                            </FlexRow>
                            <FlexRow
                                justifyContent='space-between' gap='2'
                                className='onboarding-input-row'
                            >
                                <FormGroup bottomMargin='0'>
                                    <label>Email Address</label>
                                    <input 
                                        placeholder='Enter Email Address' 
                                        type='email'
                                        name='emailAddress'
                                        value={input.emailAddress}
                                        onChange={handleInput}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                                <FormGroupWithIcon bottomMargin='0'>
                                    <label>Gender</label>
                                    <div className="input-with-icon">
                                        <select 
                                            placeholder="Select Gender"
                                            name='gender'
                                            value={input.gender}
                                            style={{color: input.gender ? '#000000' : '#667085'}}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        >
                                            <option value="">--Select Gender--</option>
                                            <option value="0">Male</option>
                                            <option value="1">Female</option>
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                            </FlexRow>
                            <FlexRow 
                                justifyContent='space-between' gap='2'
                                className='onboarding-input-row'
                            >
                                <FormGroupWithIcon bottomMargin='0'>
                                    <label>Salutation</label>
                                    <div className="input-with-icon">
                                        <select 
                                            placeholder="Select Salutation"
                                            name='salutation'
                                            value={input.salutation}
                                            style={{color: input.salutation ? '#000000' : '#667085'}}
                                            onChange={handleInput}
                                            //required
                                        >
                                            <option value="">--Select Salutation--</option>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss">Miss</option>
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                                <FormGroupWithIcon bottomMargin='0'>
                                    <label>Marital Status</label>
                                    <div className="input-with-icon">
                                        <select 
                                            placeholder="Select Status"
                                            name='maritalStatus'
                                            value={input.maritalStatus}
                                            style={{color: input.maritalStatus ? '#000000' : '#667085'}}
                                            onChange={handleInput}
                                            required
                                        >
                                            <option value="">--Select Status--</option>
                                            <option value="0">Single</option>
                                            <option value="1">Married</option>
                                            <option value="2">Divorced</option>
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                            </FlexRow>
                            { isRfsFlow &&
                                <>
                                    <FlexRow
                                        justifyContent='space-between' gap='2'
                                        className='onboarding-input-row'
                                    >
                                        <FormGroup bottomMargin='0'>
                                            <label>Place of Birth</label>
                                            <input 
                                                placeholder='Enter Place of Birth' 
                                                name='placeOfBirth'
                                                value={input.placeOfBirth}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup bottomMargin='0'>
                                            <label>Occupation</label>
                                            <input 
                                                placeholder='Enter Occupation' 
                                                name='occupation'
                                                value={input.occupation}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                    </FlexRow>
                                    <FlexRow
                                        justifyContent='space-between' gap='2'
                                        className='onboarding-input-row'
                                    >
                                        <FormGroup bottomMargin='0'>
                                            <label>Next of Kin Name</label>
                                            <input 
                                                placeholder='Enter Next of Name' 
                                                name='nextOfKinName'
                                                value={input.nextOfKinName}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup bottomMargin='0'>
                                            <label>Next of Kin Phone No.</label>
                                            <input 
                                                placeholder='Enter Phone Number' 
                                                name='nextOfKinPhoneNo'
                                                type='number'
                                                value={input.nextOfKinPhoneNo}
                                                onChange={handleInput}
                                                onKeyDown={handleTypeNumberControl}
                                                onKeyUp={handleTypeNumberControl}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                    </FlexRow>
                                </>
                            }
                            <FormGroup>
                                <label>Full Address</label>
                                <textarea 
                                    placeholder='Enter your Address' 
                                    name='fullAddress'
                                    value={input.fullAddress}
                                    onChange={handleAddressInput}
                                    required
                                    maxLength={150}
                                />
                            </FormGroup>
                        </CustomContainer>
                        <FlexRow justifyContent='flex-end' topMargin='1' gap='1.5'>
                            <Button 
                                width='9.3' height='4' bgColor="#ffffff"
                                borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                childHoverColor='#0D968F' type="button"
                                onClick={() => navigate(-1)}
                            >
                                <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                    <IoArrowBackOutline/>
                                </AppSpan>
                                Back
                            </Button>
                            <Button 
                                width='8.8' height='4' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </ScreenContainer>
            
        </>
    )
}
